import { Pipe, PipeTransform } from 'ng-metadata/core';


/**
 * @ngdoc filter
 * @name mwSanitizeInvalidHtml
 * @module mw.components.contentDocuments
 *
 * @param {string} [html] - The HTML you want sanitized
 * @param {boolean} [skipAnchors=false] - Controls if we want to skip sanitizing anchor tags
 * @returns {string} A sanitized version of the HTML that was passed in
 *
 * @description
 * `mwSanitizeInvalidHtml` sanitizes HTML that is passed in to take care of any malicious behaviors
 */
@Pipe({
    name: 'mwSanitizeInvalidHtml'
})
export class SanitizeInvalidHtmlPipe implements PipeTransform {

    transform(input, skipAnchors = false) {
        let tokensArr;
        let parsedValidHTML = input;

        // if we don't have any input don't attempt to work on it
        if (input) {
            tokensArr = this.tokenize(input);
            parsedValidHTML = this.mapTags(tokensArr, skipAnchors);
        }

        return parsedValidHTML;
    }

    mapTags(arr, skipAnchors) {
        let newArrayWithUpdatedString = [];
        // These are the valid html tags list, which need not to be encoded. More tags can be added in this array
        let tags = { '<i>':'<i>', '</i>':'</i>', '<b>':'<b>', '</b>':'</b>','<em>':'<em>', '</em>':'</em>', '<br/>': '<br/>' };
        if (skipAnchors) {
            tags['<a '] = '<a ';
            tags['noreferrer">'] = 'noreferrer">';
            tags['</a>'] = '</a>';
        }
        for (let i = 0; i < arr.length; i++) {
            if (typeof tags[arr[i]] === 'undefined') {
                arr[i] = arr[i].replace('<', '&lt;');
                arr[i] = arr[i].replace('>', '&gt;');
            }
            newArrayWithUpdatedString.push(arr[i]);
        }
        return newArrayWithUpdatedString.join('');
    }

    tokenize(str) {
        let endingChars = ' <>';
        let i = 0;
        let min = 0;
        let indexOfStart = 0;
        let newStr = '';
        let arr = [];

        while (str.length > 0) {
            min = str.length;
            for (i = 0; i < endingChars.length; i++) {
                let index = str.indexOf(endingChars[i], 1);
                if (index < min && index > -1) {
                    min = index;
                }
            }
            if (min > -1) {
                let endingChar = str.charAt(min);

                if (endingChar === '<') {
                    min = min -1;
                }

                let substr = str.substring(indexOfStart, indexOfStart + min + 1 );
                arr.push(substr);
                newStr = newStr + substr;
                str = str.substring(indexOfStart + 1 + min);
            }
        }
        return arr;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/sanitize-invalid-html.pipe.ts